import { createReducer, on } from '@ngrx/store';

import * as actions from './pdf-modal.actions';
import { pdfModalInitialState } from './pdf-modal.state';

export const pdfModalReducer = createReducer(
    pdfModalInitialState,
    on(actions.seSetModalPdfConfig, (state, { pdf, print, visible }) => ({
        ...state,
        document: pdf,
        print,
        visible
    })),
    on(actions.sePdfModalToggle, (state, { visible }) => ({
        ...state,
        visible
    }))
)
